<template lang="pug">
md-dialog.playlists#general-form-wrapper(:md-click-outside-to-close='true', :ref='dialogRef')
  md-dialog-content
  loader(:loading='loading', :size='45')
    md-dialog-actions.actions
      md-button.md-primary.md-raised.button(@click='closeDialog') X
    h1.title {{videoName}}
    md-dialog-title.md-headline(v-if="playlists.length > 0 || tags.length > 0 || serieName !== null ")
      div.moreInfo
        p <strong>Account:</strong> {{this.account !== null ? this.account.name : 'N/A'}}
        p <strong>Series name: </strong> {{this.serieName !== null ? this.serieName.name : 'N/A'}}
        p <strong>Season: </strong> {{this.seasonNumber !== null ? this.seasonNumber : 'N/A'}}
        p <strong>Episode: </strong> {{this.episodeNumber !== null ? this.episodeNumber : 'N/A'}}
        p <strong>Duration: </strong> {{this.duration}}
        p(v-if="playlists.length > 0") <strong>Playlists:</strong> 
          span(v-for="playlist in playlists.join(', ')") {{ playlist }}
        p(v-else) <strong>Playlists:</strong> N/A
        p(v-if="tags.length > 0") <strong>Tags: </strong>
          span(v-for="tag in tags.join(', ')") {{tag}}
        p(v-else) <strong>Tags: </strong> N/A
        p(v-if="licenses.length > 0") <strong>Licenses: </strong>
          span(v-for="license in licenses.join(', ')") {{license}}
        p(v-else) <strong>Licenses: </strong> N/A

    md-layout(v-else, md-align='center')
      span#no-results.md-subheading
        md-icon.md-accent(md-iconset="fa fa-exclamation-circle")
        |  No items to show

</template>

<script>
import uuid from 'uuid';
import Loader from '../../shared-components/Loader';
import mediaItemService from '../../services/mediaItemService';
import moment from 'moment';

export default {
  components: {
    Loader
  },
  props: {},
  data() {
    return {
      videoName: null,
      playlists: [],
      mediaItemId: null,
      serieId: null,
      serieName: null,
      episodeNumber: null,
      seasonNumber: null,
      account: null,
      licenses: null,
      duration: null,
      tags: [],
      loading: false,
      dialogRef: uuid.v4(),
    };
  },
  methods: {
    closeDialog() {
      this.playlist = [];
      const ref = this.dialogRef;
      this.$refs[ref].close();
      this.$emit('closed');
    },
    openDialog(mediaItemId, serieId, episodeNumber, seasonNumber) {
      this.loading = true;
      this.mediaItemId = mediaItemId;
      this.serieId = serieId;
      this.episodeNumber = episodeNumber;
      this.seasonNumber = seasonNumber;
      const ref = this.dialogRef;
      this.$refs[ref].open();
      this.fetch();
    },
    fetch() {
      this.playlists = [];
      this.videoName= null;
      this.serieName = null;
      this.episodeNumber = null;
      this.seasonNumber = null;
      this.account = null;
      this.licenses = [];
      this.duration =null;
      this.tags = [];

      // Get the data
      mediaItemService.getMediaItemInfo(this.mediaItemId)
      .then((response) => {
        this.videoName = response.data.name;
        this.playlists = response.data.playlists;
        if(this.playlists.length > 0) this.playlists = this.playlists.map((playlist) => {return playlist.name})
        this.serieName = response.data.series;
        this.episodeNumber = response.data.episodeNumber;
        this.seasonNumber = response.data.seasonNumber;
        this.account = response.data.account;
        this.licenses = response.data.licenses;
        if(this.licenses.length > 0) this.licenses = this.licenses.map((licence) => {return licence.name})
        this.tags = response.data.tags;

        var date = new Date(null);
        this.duration = response.data.videoDuration
          ? moment(date.setSeconds( response.data.videoDuration)).toISOString().substring(19, 11)
          : 'Info not available' ;
        this.loading = false;
        })
        .catch((error) => {
          console.error('Error while retrieving the list of playlist', error);
        })
    },
    mounted() {
      this.fetch();
    }
  }
};
</script>

<style lang="scss" scoped>
.md-headline {
    height: 55vh;
    overflow-y: auto;
}

.md-dialog-content{
    padding: 0px;
}

.actions {
  margin: 16px 16px 16px 0;
}

.button{
    border-radius: 5px;
    padding: 0px;
    font-size: large;
}

.title{
  display: flex;
  justify-content: center;
  font-style: italic;
  color: rgb(58, 57, 57);
}

.moreInfo{
  font-size: 16px;
  margin-top: 10px;
  margin-left: 8px;
}

</style>




// WEBPACK FOOTER //
// src/shared-components/mediaItem/AssociatedDialog.vue